import { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { FaFile } from "react-icons/fa";
import "../styles/Banner.css";

const Banner = () => {
  const [done, setDone] = useState(false);
  const sentence = " Web Developer";
  const [text, setText] = useState("");
  const [delta, setDelta] = useState(300 - Math.floor(Math.random() * 200));
  const period = 1500;

  useEffect(() => {
    const tick = () => {
      let fullText = sentence;
      let updatedText = done
        ? fullText.substring(0, text.length)
        : fullText.substring(0, text.length + 1);
      setText(updatedText);
      setDelta(done ? period : delta / 2);

      if (updatedText === fullText) {
        setDone(true);
        setDelta(period);
      }
    };
    let ticker = setInterval(() => {
      tick();
    }, delta);
    return () => {
      clearInterval(ticker);
    };
  }, [delta, done, text]);

  return (
    <section className="banner" id="home">
      <Container>
        <Row className="banner-row align-items-center">
          <Col
            style={{ position: "relative", overflow: "hidden" }}
            xs={12}
            md={12}
            xl={12}
            className="H-txt"
          >
            <span
              data-aos="fade-in"
              data-aos-easing="linear"
              data-aos-delay="1000"
              className="tagline"
            >
              Hello there👋! I'm
            </span>
            <h1
              data-aos="fade-in"
              data-aos-duration="5000"
              data-aos-easing="linear"
              data-aos-delay="1100"
            >
              <span className="main-h1">Solomon Great.</span>
              <br />
              <span
                data-aos="fade-in"
                data-aos-duration="5000"
                data-aos-delay="1200"
                className="wrap"
              >
                {text}
                <b></b>
              </span>
            </h1>
            <p
              data-aos="fade-in"
              data-aos-easing="linear"
              data-aos-delay="1300"
              data-aos-anchor=".main-h1"
            >
              Frontend developer specializing in modern, responsive websites using React, CSS, and motion. I create fast, user-centered interfaces that elevate digital products across web, mobile, and Web3.
            </p>
            <a
              href="./resume.pdf"
              target="_blank"
              rel="noreferrer"
              download="Great Solomon's pdf"
              data-aos="fade-in"
              data-aos-easing="linear"
              data-aos-delay="1400"
              data-aos-anchor=".main-h1"
            >
              <button onClick={() => console.log("let's connect")}>
                Download Resume <FaFile size={25} />
              </button>
            </a>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Banner;
